import Domain from 'enums/Domain'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const originalAuthorVerifiedResolver: FieldResolver = (metadata: Metadata) =>
  ({
    originalAuthorVerified:
      metadata.getDomain() === Domain.TWITTER && metadata.isOriginalAuthorVerified()
  } as StreamData)

export default originalAuthorVerifiedResolver
